import { ApprovedRaBillData } from "../types";

// Mock data for Approved RA Bills eligible for payment
export const mockApprovedRaBillsData: ApprovedRaBillData[] = [
  {
    id: "rab-001",
    raBillNumber: "RA/2025/URB/0007", 
    workOrderId: "WO001",
    workOrderNumber: "WO/2025/URB/0012",
    contractorId: "CONT001",
    contractorName: "ABC Infra Ltd.",
    siteId: "SITE001", 
    siteName: "Urban Rise - Tower A",
    projectId: "PROJ001",
    projectName: "Phase 2",
    raPeriod: "Jul-2025",
    raBillValue: 259120,
    alreadyPaid: 0,
    balance: 259120,
    status: "Approved",
    approvedDate: "2025-07-28",
    hasSoftHold: true,
    hasHardHold: false,
    holdReason: "Pending quality clearance",
    contractorPan: "ABCDE1234F",
    contractorBankDetails: true,
  },
  {
    id: "rab-002", 
    raBillNumber: "RA/2025/URB/0008",
    workOrderId: "WO002",
    workOrderNumber: "WO/2025/URB/0015",
    contractorId: "CONT002",
    contractorName: "XYZ Constructions",
    siteId: "SITE002",
    siteName: "Urban Rise - Tower B", 
    projectId: "PROJ002",
    projectName: "Phase 2",
    raPeriod: "Jul-2025",
    raBillValue: 212400,
    alreadyPaid: 0,
    balance: 212400,
    status: "Approved",
    approvedDate: "2025-07-30",
    hasSoftHold: false,
    hasHardHold: false,
    contractorPan: "XYZAB5678G",
    contractorBankDetails: true,
  },
  {
    id: "rab-003",
    raBillNumber: "RA/2025/URB/0009", 
    workOrderId: "WO003",
    workOrderNumber: "WO/2025/URB/0018",
    contractorId: "CONT003",
    contractorName: "BuildTech Pvt Ltd.",
    siteId: "SITE003",
    siteName: "Urban Rise - Tower C",
    projectId: "PROJ001", 
    projectName: "Phase 1",
    raPeriod: "Jun-2025",
    raBillValue: 893800,
    alreadyPaid: 700000,
    balance: 193800,
    status: "Posted",
    approvedDate: "2025-06-25",
    postedDate: "2025-06-30",
    hasSoftHold: false,
    hasHardHold: false,
    contractorPan: "BUILD9012H",
    contractorBankDetails: true,
  },
  {
    id: "rab-004",
    raBillNumber: "RA/2025/BLR/0010",
    workOrderId: "WO004", 
    workOrderNumber: "WO/2025/BLR/0025",
    contractorId: "CONT004",
    contractorName: "Galaxy Infra Private Limited",
    siteId: "SITE004",
    siteName: "Bangalore Complex",
    projectId: "PROJ003",
    projectName: "Core & Shell",
    raPeriod: "Aug-2025",
    raBillValue: 550000,
    alreadyPaid: 0,
    balance: 550000,
    status: "Approved",
    approvedDate: "2025-08-15",
    hasSoftHold: false,
    hasHardHold: false,
    contractorPan: "GALXY3456I",
    contractorBankDetails: true,
  },
  {
    id: "rab-005",
    raBillNumber: "RA/2025/CHN/0011", 
    workOrderId: "WO005",
    workOrderNumber: "WO/2025/CHN/0032",
    contractorId: "CONT005",
    contractorName: "Metro Builders & Engineers",
    siteId: "SITE005",
    siteName: "Chennai Metro Tower",
    projectId: "PROJ004",
    projectName: "Commercial Complex",
    raPeriod: "Aug-2025",
    raBillValue: 425000,
    alreadyPaid: 200000,
    balance: 225000,
    status: "Posted",
    approvedDate: "2025-08-10",
    postedDate: "2025-08-12",
    hasSoftHold: false,
    hasHardHold: false,
    contractorPan: "METRO7890J",
    contractorBankDetails: true,
  },
  {
    id: "rab-006",
    raBillNumber: "RA/2025/DEL/0012",
    workOrderId: "WO006",
    workOrderNumber: "WO/2025/DEL/0041",
    contractorId: "CONT006", 
    contractorName: "Delhi Construction Co.",
    siteId: "SITE006",
    siteName: "Delhi Heights",
    projectId: "PROJ005",
    projectName: "Residential Towers",
    raPeriod: "Jul-2025",
    raBillValue: 320000,
    alreadyPaid: 0,
    balance: 320000,
    status: "Approved",
    approvedDate: "2025-07-25",
    hasSoftHold: true,
    hasHardHold: false,
    holdReason: "Documentation pending",
    contractorPan: "DELHI2345K",
    contractorBankDetails: false, // Missing bank details
  }
];

// Helper functions
export const getApprovedRaBillById = (id: string): ApprovedRaBillData | null => {
  return mockApprovedRaBillsData.find(bill => bill.id === id) || null;
};

export const getApprovedRaBillsByContractor = (contractorId: string): ApprovedRaBillData[] => {
  return mockApprovedRaBillsData.filter(bill => bill.contractorId === contractorId);
};

export const getEligibleRaBillsForPayment = (): ApprovedRaBillData[] => {
  return mockApprovedRaBillsData.filter(bill => 
    ["Approved", "Posted"].includes(bill.status) && 
    bill.balance > 0 && 
    !bill.hasHardHold &&
    bill.contractorBankDetails
  );
};

// Master data options
export const mockContractorOptions = [
  { label: "ABC Infra Ltd.", value: "CONT001" },
  { label: "XYZ Constructions", value: "CONT002" },
  { label: "BuildTech Pvt Ltd.", value: "CONT003" },
  { label: "Galaxy Infra Private Limited", value: "CONT004" },
  { label: "Metro Builders & Engineers", value: "CONT005" },
  { label: "Delhi Construction Co.", value: "CONT006" },
];

export const mockSiteOptions = [
  { label: "Urban Rise - Tower A", value: "SITE001" },
  { label: "Urban Rise - Tower B", value: "SITE002" }, 
  { label: "Urban Rise - Tower C", value: "SITE003" },
  { label: "Bangalore Complex", value: "SITE004" },
  { label: "Chennai Metro Tower", value: "SITE005" },
  { label: "Delhi Heights", value: "SITE006" },
];

export const mockProjectOptions = [
  { label: "Phase 1", value: "PROJ001" },
  { label: "Phase 2", value: "PROJ002" },
  { label: "Core & Shell", value: "PROJ003" },
  { label: "Commercial Complex", value: "PROJ004" },
  { label: "Residential Towers", value: "PROJ005" },
];

export const mockPaymentStatusOptions = [
  { label: "Unpaid", value: "Unpaid" },
  { label: "Partially Paid", value: "Partially Paid" },
];

export const mockRaBillStatusOptions = [
  { label: "Approved", value: "Approved" },
  { label: "Posted", value: "Posted" },
];

// Additional mock data for enhanced payment lists
export const mockRetentionReleaseData = [
  {
    id: "ret-001",
    workOrderNumber: "WO/2025/URB/0012",
    contractorName: "ABC Infra Ltd.",
    siteName: "Urban Rise - Tower A",
    retentionAmount: 125000,
    releasableAmount: 75000,
    releaseDate: "2025-09-15",
    status: "Eligible for Release"
  },
  {
    id: "ret-002", 
    workOrderNumber: "WO/2025/URB/0015",
    contractorName: "XYZ Constructions",
    siteName: "Urban Rise - Tower B",
    retentionAmount: 85000,
    releasableAmount: 85000,
    releaseDate: "2025-10-01",
    status: "Ready for Release"
  }
];

export const mockSecurityDepositData = [
  {
    id: "sd-001",
    workOrderNumber: "WO/2025/URB/0012", 
    contractorName: "ABC Infra Ltd.",
    siteName: "Urban Rise - Tower A",
    securityAmount: 200000,
    refundableAmount: 200000,
    refundDate: "2025-12-31",
    status: "Refund Eligible"
  },
  {
    id: "sd-002",
    workOrderNumber: "WO/2025/BLR/0025",
    contractorName: "Galaxy Infra Private Limited", 
    siteName: "Bangalore Complex",
    securityAmount: 350000,
    refundableAmount: 300000,
    refundDate: "2026-01-15",
    status: "Partially Refundable"
  }
];

export const mockAdvanceAdjustmentData = [
  {
    id: "adv-001",
    workOrderNumber: "WO/2025/URB/0012",
    contractorName: "ABC Infra Ltd.",
    siteName: "Urban Rise - Tower A", 
    advanceGiven: 500000,
    adjustedAmount: 300000,
    pendingAdjustment: 200000,
    adjustmentType: "Against RA Bills"
  },
  {
    id: "adv-002",
    workOrderNumber: "WO/2025/CHN/0032",
    contractorName: "Metro Builders & Engineers",
    siteName: "Chennai Metro Tower",
    advanceGiven: 250000,
    adjustedAmount: 250000,
    pendingAdjustment: 0,
    adjustmentType: "Fully Adjusted"
  }
];